/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const GetDailyActivityMonitoringLogFiles = zod.object({
  "id": zod.string().uuid().optional()
});

export type GetDailyActivityMonitoringLogFiles = zod.input<typeof GetDailyActivityMonitoringLogFiles>;
export type GetDailyActivityMonitoringLogFilesOutput = zod.output<typeof GetDailyActivityMonitoringLogFiles>;
